import React from 'react';
import Pill from 'components/Pill';
import Time from 'components/Time';
export default function LastestInteractionPill(_ref) {
  var latestInteraction = _ref.latestInteraction;
  return /*#__PURE__*/React.createElement(Pill, null, /*#__PURE__*/React.createElement(Time, {
    dateTime: latestInteraction
  }));
}